import React, { useEffect } from 'react'
import HOC from '../HOC'

const HomePage = () => {
  useEffect(() => {
    // Scroll animation for arrow click
    const handleArrowClick = () => {
      const showcaseElement = document.getElementById('showcase')
      if (showcaseElement) {
        window.scrollTo({
          top: showcaseElement.offsetTop,
          behavior: 'smooth'
        })
      }
    }

    const arrow = document.getElementById('arrow')
    if (arrow) {
      arrow.addEventListener('click', handleArrowClick)
      return () => arrow.removeEventListener('click', handleArrowClick)
    }
  }, [])

  return (
    <>
      <header className="text-center">
        <img src="/images/logo_DBCS_full.png" className="img-fluid" alt="Diamond Business Consulting Services" />
        <div className="text-center">
          <i id="arrow" className="pi pi-arrow-circle-down header-icon grow" style={{ cursor: 'pointer' }}></i>
        </div>
      </header>
      <br />

      <div className="my-5"></div>

      {/* Image showcase */}
      <section id="showcase">
        <div className="container-fluid p-0">
          <div className="row no-gutters text-center">
            <div className="col-lg-6 order-lg-2 showcase-img">
              <img src="/images/file_transfer.jpg" className="img-fluid" alt="File Transfer" />
            </div>
            <div className="col-lg-6 order-lg-1 my-auto showcase-text">
              <h1>Organize</h1>
              <p className="lead">Processes that make sense and lighten the workload.</p>
            </div>
          </div>
          <div className="row no-gutters text-center">
            <div className="col-lg-6 showcase-img">
              <img src="/images/audit_checklist.jpeg" className="img-fluid" alt="Audit Checklist" />
            </div>
            <div className="col-lg-6 my-auto showcase-text">
              <h2>Audits</h2>
              <p className="lead">Reliable in-house audits that make the real thing go smoothly.</p>
            </div>
          </div>
          <div className="row no-gutters text-center">
            <div className="col-lg-6 order-lg-2 showcase-img">
              <img src="/images/automation.jpg" className="img-fluid" alt="Automation" />
            </div>
            <div className="col-lg-6 order-lg-1 my-auto showcase-text">
              <h2>Automation</h2>
              <p className="lead">Fail-safe workflows to streamline business and make your compliance rock-solid.</p>
            </div>
          </div>
        </div>
      </section>

      <hr className="short-rule" />

      <div className="col-md-8 offset-md-2">
        <h4 className="text-center text-muted">
          <b>Diamond Consulting</b> strives to reduce the burden of the compliance monitoring 
          process and to reduce the cost of and improve the administration of compliance processes 
          to better provide customer service.
        </h4>
      </div>

      <hr className="short-rule" />

      {/* Testimonials */}
      <section id="testimonials">
        <p className="lead text-center">100% of customers are fully satisfied with our services.</p>
        <div className="row">
          <div className="col-lg-1"></div>
          <div className="col-lg-10 col-md-12 col-sm-12">
            <div className="card-deck mx-auto">
              <div className="card">
                <div className="testimonial-logo mx-auto">
                  <a href="https://www.a2gov.org/Pages/default.aspx" target="_blank" rel="noopener noreferrer">
                    <img src="/images/logo_AAHC.jpg" className="card-img-top" alt="Ann Arbor Housing Commission" />
                  </a>
                </div>
                <div className="card-body">
                  <h5 className="card-title">Jennifer Hall</h5>
                  <h6 className="card-subtitle mb-2 text-muted">
                    <strong>Executive Director</strong> - Ann Arbor Housing Commission
                  </h6>
                  <p className="card-text">
                    "Without Diamond Consulting, the Ann Arbor Housing Commission would not have met 
                    our compliance requirements under the LIHTC program, which was new to us after 
                    we converted from public housing to RAD PBV."
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="testimonial-logo mx-auto">
                  <a href="http://www.welcometoyourhome.org" target="_blank" rel="noopener noreferrer">
                    <img src="/images/logo_PPM.png" className="card-img-top" alt="Premier Property Management" />
                  </a>
                </div>
                <div className="card-body">
                  <h5 className="card-title">Robert Beale</h5>
                  <h6 className="card-subtitle mb-2 text-muted">
                    <strong>President</strong> - Premier Property Management
                  </h6>
                  <p className="card-text">
                    <em>
                      "Diamond Consulting has taken our extremely difficult compliance programs and 
                      turned them into audits with minor to zero findings!"
                    </em>
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="testimonial-logo mx-auto">
                  <a href="http://www.dhsmgt.com" target="_blank" rel="noopener noreferrer">
                    <img src="/images/logo_DHS_full.jpg" className="card-img-top" alt="DHS Management" />
                  </a>
                </div>
                <div className="card-body">
                  <h5 className="card-title">Kelly Jankowski</h5>
                  <h6 className="card-subtitle mb-2 text-muted">
                    <strong>Operations Manager</strong> - DHS Management
                  </h6>
                  <p className="card-text">
                    "Diamond Consulting has taken the worry out of our compliance! With their 
                    assistance we have a solid compliance program and very few staff issues or 
                    audit findings!"
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-1"></div>
        </div>
      </section>

      {/* Why Diamond */}
      <section id="why_diamond">
        <div className="row justify-content-center">
          <h1>Why Diamond?</h1>
        </div>
        <div className="row justify-content-center">
          <p className="lead text-muted">Here's why Diamond is the best compliance solution for you!</p>
        </div>
        <div className="row">
          <div className="col-lg-2 col-md-4 col-sm-4">
            <div className="card text-center">
              <div className="card-body">
                <i className="far fa-file-alt fa-4x grow"></i>
                <div className="my-2"></div>
                <h3 className="card-title">File</h3>
                <h6 className="card-text">pre-approvals</h6>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4">
            <div className="card text-center">
              <div className="card-body">
                <i className="far fa-check-circle fa-4x grow"></i>
                <div className="my-2"></div>
                <h3 className="card-title">Property</h3>
                <h6 className="card-text">audits</h6>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4">
            <div className="card text-center">
              <div className="card-body">
                <i className="far fa-lightbulb fa-4x grow"></i>
                <div className="my-2"></div>
                <h3 className="card-title">Expert</h3>
                <h6 className="card-text">training</h6>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4">
            <div className="card text-center">
              <div className="card-body">
                <i className="far fa-clipboard fa-4x grow"></i>
                <div className="my-2"></div>
                <h3 className="card-title">Audit</h3>
                <h6 className="card-text">responses</h6>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4">
            <div className="card text-center">
              <div className="card-body">
                <i className="far fa-chart-bar fa-4x grow"></i>
                <div className="my-2"></div>
                <h3 className="card-title">Consulting</h3>
                <h6 className="card-text">performance metrics</h6>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4">
            <div className="card text-center">
              <div className="card-body">
                <i className="far fa-gem fa-4x grow"></i>
                <div className="my-2"></div>
                <h3 className="card-title">Compliance</h3>
                <h6 className="card-text">solutions</h6>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default HOC(HomePage)

